const envVersion = process.env.PACKAGE_VERSION;

interface AtomTrackingId {
  pkg?: any;
  version?: any;
}

/**
 * Create tracking ID
 * Use either pkg.json version, custom version or env variable
 * @param id
 * @param { pkg, version }
 */
export default function trackingId(
  id: string,
  { pkg = {}, version }: AtomTrackingId = {},
): string {
  const finalVersion = version || pkg.version || envVersion;

  return `@Blueprint/${id}${finalVersion ? `@${finalVersion}` : ''}`;
}
